// extracted by mini-css-extract-plugin
export default {"group":"rZvysj3V"};